import { render, staticRenderFns } from "./activity-list-share.vue?vue&type=template&id=a1506548&scoped=true"
import script from "./activity-list-share.vue?vue&type=script&lang=js"
export * from "./activity-list-share.vue?vue&type=script&lang=js"
import style0 from "./activity-list-share.vue?vue&type=style&index=0&id=a1506548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1506548",
  null
  
)

export default component.exports